import React__default, { useCallback } from 'react';

const useReactTransition = React__default["useTransition".toString()];
function useTransitionFallback() {
  const startTransition = useCallback(
    (callback) => callback(),
    []
  );
  return [false, startTransition];
}
const useTransition = useReactTransition ?? useTransitionFallback;

export { useTransition };
//# sourceMappingURL=use-transition.mjs.map
